import { render } from "./bar-chart.vue?vue&type=template&id=c36b44d8&scoped=true"
import script from "./bar-chart.vue?vue&type=script&lang=js"
export * from "./bar-chart.vue?vue&type=script&lang=js"

import "./bar-chart.vue?vue&type=style&index=0&id=c36b44d8&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36b44d8"]])

export default __exports__